
// noinspection CssUnknownTarget

import {TaskUpdate, TaskUpdateType} from "@/models/task.update";
import {isset} from "@/util/util";

/**
 *
 * @class TaskSimpleSimFailed
 *
 * sentinel progress event; an on demand simulation failed for some reason
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class TaskSimpleSimFailed extends TaskUpdate {

  /** the error message */
  public message: string;

  /** the icon to use for the file type */
  public icon:     string;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param message  the error message
   * @param icon     the icon (left side) to use if overriding
   *
   */
  constructor(id: string, message: any, icon: string) {

    super(id, TaskUpdateType.Complete, 100.0);

    this.message = this.errorToString(message);

    this.icon     = '/assets/images/cloud-run-icon-32.png';

    if (icon) {

      this.icon = icon;
    }
  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <img alt="Simulation Failed" class="tsp-icon" src="${this.icon}" width="32"></img>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px); vertical-align: top; margin-top: 4px;">

    <div style="display: block;">
      <span class="tsp-size">${this.message}</span>
    </div>

  </div>

</div>`;
  }

  /** is this task complete? */
  isComplete(): boolean {

    return true;
  }

}
